import React from 'react'
import { withStyles } from '@material-ui/core'
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { currency } from '../../../../../helpers'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 700,
    },
    bgBlack: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        border: 'solid 1px lightgrey',
    },
    bgBlueGrey: {
        backgroundColor: '#424242',
        color: theme.palette.common.white,
        border: 'solid 1px lightgrey',
    },
    bgWhite: {
        border: '1px solid #ffffff',
    },
    bgLightBlue: {
        backgroundColor: '#dbe5f1',
        color: theme.palette.common.black,
        border: '1px solid white',
    },
    bgLightGreen: {
		backgroundColor: '#6fcdb3',
		color: theme.palette.common.black,
		border: '1px solid white',
	},
    footerLabelCell:{
		border: 'solid 1px lightgrey !important',
		paddingTop: '5px !important',
        paddingBottom: '5px !important',
        textAlign: 'center'
	},
	footerLabelRow:{
		height: '0px'
	},
    noBorder: {
        border: '0 !important',
    },
    emptyRow: {
        height: '40px !important',
    },
    leftJustified: {
        textAlign: 'left !important',
    },
    reportTableContainer: {
        overflowX: 'scroll',
		paddingBottom: '15px'
    },
    salaryCell: {
		paddingRight: '7px !important',
		textAlign: 'right !important'
	},

}))

const StyledTableCell = withStyles(theme => ({
    head: {
        padding: theme.spacing(1),
        fontSize: 12,
        border: 'solid 1px lightgrey',
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    body: {
        fontSize: 11,
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    footer: {
		textAlign: 'center',
	},
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
    root: {
        height: 'auto',
    },
}))(TableRow)


export default function AverageCostOfLaborSummaryReport(props) {

    const classes = useStyles()

    return (
        <div className={classes.reportTableContainer}>
            <Table id="AverageCostOfLaborSummaryReport" className={classes.reportTable} size="small">
                <TableHead>
                    <TableRow>
					<StyledTableCell colSpan={3} className={clsx(classes.noBorder, classes.alignLeft)}>
							{`Currency: ${props.currencyCode}`}
						</StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell colSpan={1} className={classes.noBorder}></StyledTableCell>
                        <StyledTableCell colSpan={1} className={classes.noBorder}></StyledTableCell>
                        <StyledTableCell colSpan={4} className={classes.bgWhite}>
                            Current
                        </StyledTableCell>
                        <StyledTableCell colSpan={4} className={classes.bgWhite}>
                            Growth
                    </StyledTableCell>
                        <StyledTableCell colSpan={4} className={classes.bgWhite}>
                            Future
                        </StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell className={classes.bgBlack}>
                            Global Grade
						</StyledTableCell>
                        <StyledTableCell className={classes.noBorder}></StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            n
						</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            Total($)
									</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            Average($)
						    		</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            %
									</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            n
									</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            Total($)
									</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            Average($)
						    		</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            %
									</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            n
									</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            Total($)
									</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            Average($)
						    		</StyledTableCell>
                        <StyledTableCell className={classes.bgBlueGrey}>
                            %
									</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.levelsData.map((levelData, i) => {
                            return (
                                <StyledTableRow key={i}>
                                    <StyledTableCell className={classes.bgBlack}>
                                        {i}
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.noBorder}></StyledTableCell>
									<StyledTableCell className={classes.bgWhite}>
										{levelData.current.totalN}
									</StyledTableCell>
									<StyledTableCell className={clsx(classes.bgWhite, classes.salaryCell)}>
										{currency(levelData.current.totalSalary, props.currencyCode)}
									</StyledTableCell>
                                    <StyledTableCell className={clsx(classes.bgWhite, classes.salaryCell)}>
										{currency(levelData.current.averageTotalSalary, props.currencyCode)}
									</StyledTableCell>
									<StyledTableCell className={classes.bgWhite}>
										{levelData.current.percent}
									</StyledTableCell>

									<StyledTableCell className={classes.bgWhite}>
										{levelData.growth.totalN}
									</StyledTableCell>
									<StyledTableCell className={clsx(classes.bgWhite, classes.salaryCell)}>
										{currency(levelData.growth.totalSalary, props.currencyCode)}
									</StyledTableCell>
                                    <StyledTableCell className={clsx(classes.bgWhite, classes.salaryCell)}>
										{currency(levelData.growth.averageTotalSalary, props.currencyCode)}
									</StyledTableCell>
									<StyledTableCell className={classes.bgWhite}>
										{levelData.growth.percent}
									</StyledTableCell>

									<StyledTableCell className={classes.bgWhite}>
										{levelData.future.totalN}
									</StyledTableCell>
									<StyledTableCell className={clsx(classes.bgWhite, classes.salaryCell)}>
										{currency(levelData.future.totalSalary, props.currencyCode)}
									</StyledTableCell>
                                    <StyledTableCell className={clsx(classes.bgWhite, classes.salaryCell)}>
										{currency(levelData.future.averageTotalSalary, props.currencyCode)}
									</StyledTableCell>
									<StyledTableCell className={classes.bgWhite}>
										{levelData.future.percent}
									</StyledTableCell>
                                </StyledTableRow>
                            )
                        })
                    }
					<StyledTableRow>
                        <StyledTableCell className={classes.noBorder}></StyledTableCell>
                    </StyledTableRow>
                </TableBody>
                <TableFooter>
                    <StyledTableRow>
                        <StyledTableCell className={classes.bgLightGreen}>Total {props.groupSummary.current.totalN}</StyledTableCell>
                        <StyledTableCell colSpan={1} className={classes.noBorder}></StyledTableCell>

                        <StyledTableCell className={classes.bgLightGreen}>
							{props.groupSummary.current.totalN}
						</StyledTableCell>
                        <StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
							{currency(props.groupSummary.current.totalSalary, props.currencyCode)}
						</StyledTableCell>
                        <StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
							{
								props.groupSummary.current.totalN !== 0 ?
									currency(props.groupSummary.current.totalSalary / props.groupSummary.current.totalN, props.currencyCode)
									:
									null
							}
						</StyledTableCell>
                        <StyledTableCell className={classes.bgLightGreen}>
                            {props.groupSummary.current.totalPercent}
                        </StyledTableCell>
						<StyledTableCell className={classes.bgLightGreen}>
							{props.groupSummary.growth.totalN}
						</StyledTableCell>
                        <StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
							{currency(props.groupSummary.growth.totalSalary, props.currencyCode)}
						</StyledTableCell>
                        <StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
							{
								props.groupSummary.growth.totalN !== 0 ?
									currency(props.groupSummary.growth.totalSalary / props.groupSummary.growth.totalN, props.currencyCode)
									:
									''
							}
						</StyledTableCell>
                        <StyledTableCell className={classes.bgLightGreen}>
                            {props.groupSummary.growth.totalPercent}
                        </StyledTableCell>
                        <StyledTableCell className={classes.bgLightGreen}>
							{props.groupSummary.future.totalN}
						</StyledTableCell>
                        <StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
							{currency(props.groupSummary.future.totalSalary, props.currencyCode)}
						</StyledTableCell>
                        <StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
							{
								props.groupSummary.future.totalN !== 0 ?
									currency(props.groupSummary.future.totalSalary / props.groupSummary.future.totalN, props.currencyCode)
									:
									''
							}
						</StyledTableCell>
                        <StyledTableCell className={classes.bgLightGreen}>
                            {props.groupSummary.future.totalPercent}
                        </StyledTableCell>
                    </StyledTableRow>
                    <TableRow className={classes.footerLabelRow}>
                        <StyledTableCell colSpan={2} className={classes.noBorder}></StyledTableCell>
                        <StyledTableCell colSpan={4} className={classes.footerLabelCell}>
                            Current
                        </StyledTableCell>
                        <StyledTableCell colSpan={4} className={classes.footerLabelCell}>
                            Growth
                    	</StyledTableCell>
                        <StyledTableCell colSpan={4} className={classes.footerLabelCell}>
                            Future
                        </StyledTableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        </div >
    )
}
